// Этапы кандидатуры словами — карточка кандидата и списки мобильной версии.
// Superset of stage tokens returned by the backend for a candidate (see
// KanbanCandidate.stage). We render the raw token if it's missing here.
//
// Бекенд держит ту же копию в shared_db (STAGE_LABELS / STATUS_LABELS /
// SOURCE_LABELS): из неё chat-service пишет строки смены этапа в ленту, а
// ats-api — историю правой панели. Правите подпись здесь — правьте и там,
// иначе лента скажет одно, а меню — другое.
export const STAGE_LABEL: Record<string, string> = {
  recommended: "Рекомендовано",
  application_received: "Отклик получен",
  invitation_sent: "Приглашение отправлено",
  in_bot: "В боте",
  vacancy_intro: "Знакомство",
  questionnaire: "Анкетирование",
  screening: "Скрининг",
  scoring: "Скоринг",
  bot_invited: "Пригласили в бот",
  bot_started: "Вошёл в бот",
  form_pending: "Ждём анкету",
  landing_opened: "Открыл лендинг",
  form_received: "Анкета получена",
  handed_off: "Передан рекрутёру",
  awaiting_decision: "Ждут решения",
  slots_sent: "Слоты отправлены",
  meeting_scheduled: "Встреча назначена",
  meeting_held: "Встреча проведена",
  test_sent: "Тестовое выдано",
  test_done: "Тестовое выполнено",
  offer_made: "Оффер сделан",
  hired: "Нанят",
  not_passed: "Отказ",
};

/** Этап словами; незнакомый — как пришёл. */
export function stageLabel(stage: string | null | undefined): string | null {
  if (!stage) return null;
  return STAGE_LABEL[stage] ?? stage;
}

/** Статус кандидатуры (CandidateStatus) словами. Закрыта может быть не
 *  только отказом: кандидат отказался сам, не дозвонились, вышел на работу. */
export const STATUS_LABEL: Record<string, string> = {
  active: "В работе",
  not_passed: "Отказ",
  self_declined: "Кандидат отказался",
  not_reached: "Не дозвонились",
  no_consent: "Нет согласия",
  passed: "Вышел на работу",
};

/** Статус словами; незнакомый — как пришёл. */
export function statusLabel(status: string | null | undefined): string | null {
  if (!status) return null;
  return STATUS_LABEL[status] ?? status;
}

/** Кандидатура закрыта (любой статус, кроме «в работе») — вместо этапа
 *  показываем, чем закрыта. Пустой статус — старые ответы без поля: в работе. */
export function isClosedStatus(status: string | null | undefined): boolean {
  return !!status && status !== "active";
}

/** Кто сменил этап без человека — `source` события журнала этапов словами
 *  (как в строке ленты: «автоматически: кандидат записался на слот»). Ручные
 *  источники (manual, reject, bulk_reject, reactivate, llm_revert) сюда не
 *  входят: у них есть автор, его и показываем. Не путать с
 *  lib/candidateSources — там «Добавлен как» (откуда кандидатура вообще
 *  взялась).
 *
 *  `llm` здесь — предложение Девы, применённое само (сисадмин включил
 *  «Применять сразу»): «автоматически: Дева по переписке». Применил рекрутёр
 *  («Анна Коваль: по предложению Девы») или вернул («Анна Коваль: отмена
 *  решения Девы») — подпись человека присылает сервер (shared_db
 *  HUMAN_SOURCE_LABELS), копии здесь нет. */
export const EVENT_SOURCE_LABEL: Record<string, string> = {
  slots: "кандидат записался на слот",
  booking: "запись на встречу",
  chat: "отправлена ссылка на слоты",
  landing: "анкета с лендинга",
  bot_invite: "отправлена ссылка на бота",
  auto_invite: "отправлена ссылка на бота",
  bot_link: "кандидат перешёл по ссылке в бот",
  bot_phone: "кандидат найден в боте по телефону",
  landing_open: "кандидат открыл лендинг",
  check: "кандидат сдал тест по ссылке",
  observer: "Дева по переписке",
  llm: "Дева по переписке",
  manual_review: "разбор отклика",
  screening: "скрининг",
  hh: "статус на hh.ru",
  meeting: "по итогам встречи",
  reconcile: "автоматически",
  internal: "автоматически",
  auto_reject: "автоматически",
};

export const AUTO_LABEL = "автоматически";

/** Источник смены словами; незнакомый — просто «автоматически». */
export function eventSourceLabel(source: string | null | undefined): string {
  return (source && EVENT_SOURCE_LABEL[source]) || AUTO_LABEL;
}
